<template>
    <v-card>
        <v-toolbar color="primary">
            <v-spacer></v-spacer>
            <v-toolbar-title style="color: white">
                Transferir posto
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pa-4">
            <v-alert v-if="alert" type="error" class="pa-1" :value="true">
                Dados passados são insufucientes.
            </v-alert>
            <h6 style="width: 100%; text-align: center; font-size: 1em;">Digite os dados da pessoa que você deseja transferir o posto {{posto.nome_fantasia}}</h6>
            <v-text-field
              label="Nome"
              v-model="nome"
              :rules="[
                (v) => !!v || 'O nome é obrigatório'
              ]"
            />
            <v-text-field
              label="Sobrenome"
              v-model="sobrenome"
              :rules="[
                (v) => !!v || 'O sobrenome é obrigatório'
              ]"
            />
            <v-text-field
              label="CPF"
              v-model="cpf"
              mask="###.###.###-##"
              :rules="[
                (v) => !!v || 'O CPF é obrigatório'
              ]"
            />
            <v-text-field
              label="Email"
              v-model="email"
              :rules="[
                (v) => !!v || 'O email é obrigatório'
              ]"
            />
            <v-text-field
              label="Telefone"
              mask="(##) # ####-####"
              v-model="telefone"
              :rules="[
                (v) => !!v || 'O telefone é obrigatório'
              ]"
            />
        </v-card-text>
        <v-card-actions class="justify-space-between pa-3">
            <v-btn @click="fechar">Voltar</v-btn>
            <v-btn color="primary" :disabled="this.cpf === '' || this.email === '' || this.nome === '' || this.sobrenome === '' || this.telefone === ''" @click="transferirPosto">Transfeir</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['posto'],
  data () {
    return {
      step: 1,
      cpf: '',
      email: '',
      nome: '',
      sobrenome: '',
      telefone: '',
      alert: false
    }
  },
  methods: {
    fechar () {
      this.cpf = ''
      this.email = ''
      this.nome = ''
      this.sobrenome = ''
      this.telefone = ''
      this.alert = false
      this.$emit('fechar')
    },
    async transferirPosto () {
      await this.$store.dispatch('signUserUp', {
        email: this.email,
        password: this.cpf,
        logar: false
      })

      this.$store.dispatch('transferirPosto', {
        cpf: this.cpf,
        email: this.email,
        nome: this.nome,
        sobrenome: this.sobrenome,
        telefone: this.telefone,
        cnpj: this.posto.cnpj
      }).then(() => {
        this.fechar()
        this.$emit('resposta', {
          text: 'A sua solicitação foi enviada',
          color: 'primary'
        })
      }).catch(() => {
        this.$emit('resposta', {
          text: 'Não foi póssível enviar solicitação, entre em contato com a Apetrus.',
          color: 'error'
        })
      })
    }
  }
}
</script>
